export default "__VITE_ASSET__7a1214f4__"